export const SUBSCRIPTION_ROUTE_PATH = {
  subscriptions: {
    list: { path: "/subscriptions" },
    mySubscription: { path: "/my-subscription" },
    purchase: { path: "/purchase" },
    guidance: { path: "/guidance" },
  },
  paymentReceipts: {
    list: { path: "/payment-receipts" },
  },
  settings: {
    vpn: { path: "/settings/vpn" },
    payment: { path: "/settings/payment" },
  },
};
